<template>
  <div class="pulmikort">
    <div class="content">
      <h1 class="pulmikort__title">Лечить, нельзя игнорировать</h1>
    </div>
    <Breadcrumbs
      :pages="[
        {
          name: 'Терапевтические области',
          link: { name: 'Nosology' },
        },
        {
          name: 'Пульмонология',
          link: { path: '/therapeutic-areas/pulmonology' },
        },
        {
          name: 'Лечить, нельзя игнорировать',
        },
      ]"
    />
    <div class="content">
      <div class="pulmikort__body">
        <div class="pulmikort__content">
          <div class="pulmikort__banner">
            <div class="pulmikort__banner-text">
              <div class="pulmikort__banner-title">
                Информационный проект, подготовленный при участии д.м.н.,
                профессора Зайцевой О.В.
              </div>
              <div class="pulmikort__banner-description">
                Практические аспекты диагностики и терапии заболеваний верхних и
                нижних дыхательных путей у детей.
              </div>
            </div>
          </div>
          <div class="pulmikort__video">
            <video
              oncontextmenu="return false"
              controls
              controlsList="nodownload"
              :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/pulmikort/1.mp4`"
              :poster="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/pulmikort/video.jpg`"
            ></video>
          </div>
          <div class="pulmikort__tabs">
            <div
              class="pulmikort__tab"
              :class="{ pulmikort__tab_active: activeTab == 0 }"
              @click="choiceTab(0)"
            >
              Клинические рекомендации 2024
            </div>
            <div
              class="pulmikort__tab"
              :class="{ pulmikort__tab_active: activeTab == 1 }"
              @click="choiceTab(1)"
            >
              Настороженность БА и БОС
            </div>
            <div
              class="pulmikort__tab"
              :class="{ pulmikort__tab_active: activeTab == 2 }"
              @click="choiceTab(2)"
            >
              Гормонофобия: мифы и&nbsp;реальность
            </div>
            <div
              class="pulmikort__tab"
              :class="{ pulmikort__tab_active: activeTab == 3 }"
              @click="choiceTab(3)"
            >
              БА: базисная терапия
            </div>
            <div
              class="pulmikort__tab"
              :class="{ pulmikort__tab_active: activeTab == 4 }"
              @click="choiceTab(4)"
            >
              Неотложные состояния
            </div>
          </div>
          <div
            class="pulmikort__tab pulmikort__tab_mobile my-4"
            :class="{ pulmikort__tab_active: activeTab == 0 }"
            @click="choiceTab(0)"
          >
            Клинические рекомендации 2024
          </div>
          <div v-if="activeTab == 0">
            <input
              @change="toggleSource($event.target.checked)"
              id="tab1"
              type="checkbox"
              class="pulmikort__tabs-body-trigger"
            />
            <div class="pulmikort__tabs-body">
              <div class="pulmikort__tabs-body-speaker">
                <div class="pulmikort__tabs-body-speaker-avatar">
                  <img
                    :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/pulmikort/speaker.jpg`"
                  />
                </div>
                <div class="pulmikort__tabs-body-speaker-info">
                  <div class="pulmikort__tabs-body-speaker-name">
                    Профессор Зайцева О.В.
                  </div>
                  <div class="pulmikort__tabs-body-speaker-description">
                    «Своевременная диагностика БА и адекватная терапия,
                    соответствующая современным клиническим рекомендациям, может
                    обеспечить здоровье ребенка на долгие годы!»*
                  </div>
                </div>
              </div>
              <div class="pulmikort__tabs-body-title">
                Клинические рекомендации 2024
              </div>

              <div class="pulmikort__tabs-body-tabs">
                <div
                  :data-coolbox="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/pulmikort/1/%D0%9F%D1%83%D0%BB%D1%8C%D0%BC%D0%B8%D0%BA%D0%BE%D1%80%D1%82.mp4`"
                  class="pulmikort__tabs-body-tab"
                >
                  <div class="pulmikort__tabs-body-tab-icon">
                    <img
                      :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/pulmikort/icon1.svg`"
                    />
                  </div>
                  <div class="pulmikort__tabs-body-tab-title">
                    Видео эксперта
                  </div>
                </div>
                <a
                  :href="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/pulmikort/1/%D0%9C%D0%B0%D1%82%D0%B5%D1%80%D0%B8%D0%B0%D0%BB%20%D0%B4%D0%BB%D1%8F%20%D1%81%D0%BA%D0%B0%D1%87%D0%B8%D0%B2%D0%B0%D0%BD%D0%B8%D1%8F.pdf`"
                  target="_blank"
                  class="pulmikort__tabs-body-tab"
                >
                  <div class="pulmikort__tabs-body-tab-icon">
                    <img
                      :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/pulmikort/icon2.svg`"
                    />
                  </div>
                  <div class="pulmikort__tabs-body-tab-title">
                    Полезный материал
                  </div>
                </a>

                <label for="tab1" class="pulmikort__tabs-body-tab">
                  <div class="pulmikort__tabs-body-tab-icon">
                    <img
                      :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/pulmikort/icon3.svg`"
                    />
                  </div>
                  <div class="pulmikort__tabs-body-tab-title">
                    Пульмикорт<sup>®</sup> суспензия
                  </div>
                </label>
              </div>
              <div class="pulmikort__tabs-body-content">
                <img
                  class="mb-8"
                  :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/pulmikort/1-1.jpg 2x`"
                />
                <div class="d-flex mb-4">
                  <div class="mr-2" style="width: 28px; flex-shrink: 0">
                    <img
                      style="width: 100%"
                      :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/pulmikort/plus.png 2x`"
                    />
                  </div>
                  <div>
                    <div class="text-1">
                      Быстро растворяется в дыхательных путях и снимает
                      воспаление<sup>1-3</sup>
                    </div>
                  </div>
                </div>
                <div class="d-flex mb-4">
                  <div class="mr-2" style="width: 28px; flex-shrink: 0">
                    <img
                      style="width: 100%"
                      :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/pulmikort/plus.png 2x`"
                    />
                  </div>
                  <div>
                    <div class="text-1">
                      Снижает
                      <span style="color: #00bc88">на 52%</span> риск
                      госпитализаций по поводу обострения и
                      <span style="color: #00bc88">в 2 раза</span> - риск
                      повторных обострений<sup>4,5</sup>**
                    </div>
                  </div>
                </div>
                <div class="d-flex mb-4">
                  <div class="mr-2" style="width: 28px; flex-shrink: 0">
                    <img
                      style="width: 100%"
                      :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/pulmikort/plus.png 2x`"
                    />
                  </div>
                  <div>
                    <div class="text-1">
                      <span style="color: #00bc88"
                        >Обладает благоприятным профилем безопасности</span
                      >
                      для маленьких пациентов<sup>7</sup>
                    </div>
                  </div>
                </div>
                <div class="d-flex">
                  <div class="mr-2" style="width: 28px; flex-shrink: 0">
                    <img
                      style="width: 100%"
                      :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/pulmikort/plus.png 2x`"
                    />
                  </div>
                  <div class="my-auto">
                    <div class="text-1">
                      Пульмикорт<sup>®</sup> суспензия:
                      <span style="color: #00bc88">как дозировать препарат</span
                      ><sup>7</sup>
                    </div>
                  </div>
                </div>
                <hr class="my-8" style="color: #d6d6d6" />
                <div class="title-1 mb-8">
                  Пульмикорт<sup>®</sup> суспензия (будесонид) быстро
                  растворяется в дыхательных путях и снимает воспаление<sup
                    >1-3</sup
                  >
                </div>
                <picture>
                  <source
                    :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/pulmikort/1-2_mob.jpg 2x`"
                    media="(max-width: 767px)"
                  />
                  <img
                    class="mb-8"
                    :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/pulmikort/1-2.jpg 2x`"
                  />
                </picture>

                <hr class="my-8" style="color: #d6d6d6" />
                <div class="title-1 mb-8">
                  Контроль бронхиальной астмы в зависимости от длительности
                  терапии<sup>6</sup>
                </div>
                <img
                  class="mb-8"
                  :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/pulmikort/1-3.jpg 2x`"
                />
                <hr class="my-8" style="color: #d6d6d6" />
                <div class="title-1 mb-8">
                  Пульмикорт<sup>®</sup> суспензия обладает благоприятным
                  профилем безопасности для маленьких пациентов<sup>7</sup>
                </div>
                <div class="d-flex mb-4">
                  <div class="mr-2 mt-1" style="width: 28px; flex-shrink: 0">
                    <div
                      style="
                        width: 10px;
                        height: 10px;
                        background-color: #00bc88;
                        border-radius: 50%;
                      "
                    ></div>
                  </div>
                  <div>
                    <div class="text-1">
                      можно использовать с 6 месяцев, в период беременности и
                      кормления грудью
                    </div>
                  </div>
                </div>
                <div class="d-flex">
                  <div class="mr-2 mt-1" style="width: 28px; flex-shrink: 0">
                    <div
                      style="
                        width: 10px;
                        height: 10px;
                        background-color: #00bc88;
                        border-radius: 50%;
                      "
                    ></div>
                  </div>
                  <div>
                    <div class="text-1">
                      клиническая эффективность и безопасность препарата
                      Пульмикорт<sup>®</sup> изучены в 48 клинических
                      исследованиях у детей в возрасте до 18 лет1
                    </div>
                  </div>
                </div>
                <hr class="my-8" style="color: #d6d6d6" />
                <div class="title-1 mb-8">
                  Пульмикорт<sup>®</sup> суспензия: как правильно дозировать
                  препарат<sup>7</sup>
                </div>
                <div class="text-1 mb-8">
                  В любой небуле всегда один объем лекарства - 2 мл. Разовая
                  доза суспензии более 2 мл не труебует разведения.
                </div>
                <picture>
                  <source
                    :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/pulmikort/1-4_mob.jpg 2x`"
                    media="(max-width: 767px)"
                  />
                  <img
                    class="mb-8"
                    :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/pulmikort/1-4.jpg 2x`"
                  />
                </picture>
              </div>
            </div>
            <div @click="toTop()" class="pulmikort__to-top button button_green">
              В начало
              <svg
                width="11"
                height="15"
                viewBox="0 0 11 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.273267 6.76315C0.098294 6.58813 -3.35959e-07 6.35077 -3.46777e-07 6.10329C-3.57595e-07 5.8558 0.0982939 5.61845 0.273267 5.44342L4.47327 1.24342C4.64829 1.06845 4.88565 0.970154 5.13313 0.970154C5.38062 0.970154 5.61797 1.06845 5.793 1.24342L9.993 5.44342C10.163 5.61945 10.2571 5.85521 10.255 6.09993C10.2528 6.34465 10.1547 6.57874 9.98163 6.75178C9.80858 6.92483 9.57449 7.02299 9.32977 7.02512C9.08506 7.02724 8.8493 6.93317 8.67327 6.76315L6.06647 4.23662L6.06647 13.1033C6.06647 13.3508 5.96813 13.5882 5.7931 13.7633C5.61807 13.9383 5.38067 14.0366 5.13313 14.0366C4.8856 14.0366 4.6482 13.9383 4.47317 13.7633C4.29813 13.5882 4.1998 13.3508 4.1998 13.1033L4.1998 4.23662L1.593 6.76315C1.41797 6.93813 1.18062 7.03642 0.933134 7.03642C0.685647 7.03642 0.448293 6.93813 0.273267 6.76315Z"
                  fill="white"
                />
              </svg>
            </div>
          </div>
          <div
            class="pulmikort__tab pulmikort__tab_mobile my-4"
            :class="{ pulmikort__tab_active: activeTab == 1 }"
            @click="choiceTab(1)"
          >
            Настороженность БА и БОС
          </div>
          <div v-if="activeTab == 1">
            <input
              @change="toggleSource($event.target.checked)"
              id="tab2"
              type="checkbox"
              class="pulmikort__tabs-body-trigger"
            />
            <div class="pulmikort__tabs-body">
              <div class="pulmikort__tabs-body-speaker">
                <div class="pulmikort__tabs-body-speaker-avatar">
                  <img
                    :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/pulmikort/speaker.jpg`"
                  />
                </div>
                <div class="pulmikort__tabs-body-speaker-info">
                  <div class="pulmikort__tabs-body-speaker-name">
                    Профессор Зайцева О.В.
                  </div>
                  <div class="pulmikort__tabs-body-speaker-description">
                    «Важно помнить, что бронхообструкция может возникать не
                    только на фоне астмы, но также может быть ее основным
                    симптомом. Определение причины и своевременная эффективная
                    терапия в каждом случае черезвычайно важны!»*
                  </div>
                </div>
              </div>
              <div class="pulmikort__tabs-body-title">БОС и диагностика БА</div>

              <div class="pulmikort__tabs-body-tabs">
                <div
                  :data-coolbox="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/pulmikort/2/%D0%9F%D1%83%D0%BB%D1%8C%D0%BC%D0%B8%D0%BA%D0%BE%D1%80%D1%82.mp4`"
                  class="pulmikort__tabs-body-tab"
                >
                  <div class="pulmikort__tabs-body-tab-icon">
                    <img
                      :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/pulmikort/icon1.svg`"
                    />
                  </div>
                  <div class="pulmikort__tabs-body-tab-title">
                    Видео эксперта
                  </div>
                </div>
                <a
                  :href="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/pulmikort/2/%D0%9C%D0%B0%D1%82%D0%B5%D1%80%D0%B8%D0%B0%D0%BB%20%D0%B4%D0%BB%D1%8F%20%D1%81%D0%BA%D0%B0%D1%87%D0%B8%D0%B2%D0%B0%D0%BD%D0%B8%D1%8F.pdf`"
                  target="_blank"
                  class="pulmikort__tabs-body-tab"
                >
                  <div class="pulmikort__tabs-body-tab-icon">
                    <img
                      :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/pulmikort/icon2.svg`"
                    />
                  </div>
                  <div class="pulmikort__tabs-body-tab-title">
                    Полезный материал
                  </div>
                </a>

                <label for="tab2" class="pulmikort__tabs-body-tab">
                  <div class="pulmikort__tabs-body-tab-icon">
                    <img
                      :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/pulmikort/icon3.svg`"
                    />
                  </div>
                  <div class="pulmikort__tabs-body-tab-title">
                    Пульмикорт<sup>®</sup> суспензия
                  </div>
                </label>
              </div>
              <div class="pulmikort__tabs-body-content">
                <div class="d-flex">
                  <div class="mr-xl-4">
                    <div class="title-1 mb-8">
                      БОС как дебют бронхиальной астмы
                    </div>
                    <div class="text-2">
                      БОС может маскировать проявления бронхиальной астмы, около
                      25% детей имеют повторные эпизоды<sup>1</sup>.
                      <br />
                      <img
                        style="border-radius: 10px"
                        class="d-xl-none my-4"
                        :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/pulmikort/2-1.jpg`"
                      />
                      Почти у половины детей раннего возраста,
                      госпитализированных по поводу БОС, это заболевание
                      является дебютом БА<sup>1</sup>.
                    </div>
                    <a
                      href="#"
                      class="button button_pink mt-8 mx-md-auto mx-xl-0"
                    >
                      Перейти к памятке
                    </a>
                  </div>
                  <div
                    class="ml-4 d-none d-xl-block"
                    style="flex-basis: 50%; flex-shrink: 0"
                  >
                    <img
                      style="border-radius: 20px"
                      :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/pulmikort/2-1.jpg`"
                    />
                  </div>
                </div>
                <hr class="my-8" style="color: #d6d6d6" />
                <div class="d-flex">
                  <div
                    class="mr-4 d-none d-xl-block"
                    style="flex-basis: calc(50% - 32px); flex-shrink: 0"
                  >
                    <img
                      :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/pulmikort/2-2.jpg`"
                    />
                  </div>
                  <div class="ml-xl-4">
                    <div class="title-1 mb-8">
                      Клинические критерии вероятного дебюта БА на фоне
                      БОС<sup>1-4</sup>:
                    </div>
                    <div class="d-flex mb-4">
                      <div
                        class="mr-2 mt-1"
                        style="width: 10px; flex-shrink: 0"
                      >
                        <div
                          style="
                            width: 10px;
                            height: 10px;
                            background-color: #00bc88;
                            border-radius: 50%;
                          "
                        ></div>
                      </div>
                      <div>
                        <div class="text-2">≥3 эпизодов в год;</div>
                      </div>
                    </div>
                    <div class="d-flex mb-4">
                      <div
                        class="mr-2 mt-1"
                        style="width: 10px; flex-shrink: 0"
                      >
                        <div
                          style="
                            width: 10px;
                            height: 10px;
                            background-color: #00bc88;
                            border-radius: 50%;
                          "
                        ></div>
                      </div>
                      <div>
                        <div class="text-2">
                          наличие аллергологических маркеров (эозинофилия крови,
                          повышение IgE);
                        </div>
                      </div>
                    </div>
                    <div class="d-flex">
                      <div
                        class="mr-2 mt-1"
                        style="width: 10px; flex-shrink: 0"
                      >
                        <div
                          style="
                            width: 10px;
                            height: 10px;
                            background-color: #00bc88;
                            border-radius: 50%;
                          "
                        ></div>
                      </div>
                      <div>
                        <div class="text-2">
                          отягощенный семейный аллергоанамнез.
                        </div>
                      </div>
                    </div>
                    <img
                      class="d-xl-none mt-4"
                      :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/pulmikort/2-2.jpg`"
                    />
                    <a
                      href="#"
                      class="button button_pink mt-8 mx-md-auto mx-xl-0"
                    >
                      Больше о БОС и БА
                    </a>
                  </div>
                </div>
                <hr class="my-8" style="color: #d6d6d6" />
                <div class="d-flex">
                  <div class="mr-xl-4">
                    <div class="title-1 mb-8">
                      Роль препарата Пульмикорт<sup>®</sup> суспензия в
                      диагностике и терапии БА
                    </div>
                    <div class="d-flex mb-4">
                      <div class="mr-2" style="width: 28px; flex-shrink: 0">
                        <img
                          style="width: 100%"
                          :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/pulmikort/plus.png 2x`"
                        />
                      </div>
                      <div>
                        <div class="text-2">
                          При высоком риске БА назначается противовоспалительная
                          терапия ИГКС, например, будесонид (Пульмикорт<sup
                            >®</sup
                          >
                          суспензия), на 2-3 месяца<sup>1-4</sup>.
                        </div>
                      </div>
                    </div>
                    <div class="d-flex mb-4">
                      <div class="mr-2" style="width: 28px; flex-shrink: 0">
                        <img
                          style="width: 100%"
                          :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/pulmikort/plus.png 2x`"
                        />
                      </div>
                      <div>
                        <div class="text-2">
                          Диагноз БА становится вероятным, если на фоне терапии
                          наступает клиническое улучшение, а после ее отмены —
                          ухудшение состояния<sup>1-3</sup>.
                        </div>
                      </div>
                    </div>
                    <div
                      class="py-4 px-4 d-xl-none mb-4"
                      style="border-radius: 20px; border: 2px solid #00bc88"
                    >
                      <img
                        style="width: 60px"
                        class="mx-auto mb-4"
                        :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/pulmikort/mark.svg`"
                      />
                      <div class="text-1" style="text-align: center">
                        Раннее назначение ИГКС, в том числе будесонида
                        (Пульмикорт<sup>®</sup>), помогает не только купировать
                        острые приступы, но и предотвратить развитие
                        хронического воспаления и ремоделирования дыхательных
                        путей<sup>1,4</sup>.
                      </div>
                    </div>
                    <div class="d-flex">
                      <div class="mr-2" style="width: 28px; flex-shrink: 0">
                        <img
                          style="width: 100%"
                          :srcset="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/pulmikort/plus.png 2x`"
                        />
                      </div>
                      <div>
                        <div class="text-2">
                          Ингаляции Пульмикорт<sup>®</sup> суспензия через
                          небулайзер способствуют уменьшению госпитализаций на
                          40–60% при раннем применении<sup>5,6</sup>.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="ml-4 d-none d-xl-flex"
                    style="flex-basis: 40%; flex-shrink: 0"
                  >
                    <div
                      class="py-4 px-4 mt-auto"
                      style="border-radius: 20px; border: 2px solid #00bc88"
                    >
                      <img
                        style="width: 60px"
                        class="mx-auto mb-4"
                        :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/pulmikort/mark.svg`"
                      />
                      <div class="text-1" style="text-align: center">
                        Раннее назначение ИГКС, в том числе будесонида
                        (Пульмикорт<sup>®</sup>), позволяет не только купировать
                        острые приступы, но и предотвратить развитие
                        хронического воспаления и ремоделирования дыхательных
                        путей<sup>1,4</sup>.
                      </div>
                    </div>
                  </div>
                </div>
                <a href="#" class="button button_pink mt-8">
                  ИГКС в терапии БА
                </a>
              </div>
            </div>
            <div @click="toTop()" class="pulmikort__to-top button button_green">
              В начало
              <svg
                width="11"
                height="15"
                viewBox="0 0 11 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.273267 6.76315C0.098294 6.58813 -3.35959e-07 6.35077 -3.46777e-07 6.10329C-3.57595e-07 5.8558 0.0982939 5.61845 0.273267 5.44342L4.47327 1.24342C4.64829 1.06845 4.88565 0.970154 5.13313 0.970154C5.38062 0.970154 5.61797 1.06845 5.793 1.24342L9.993 5.44342C10.163 5.61945 10.2571 5.85521 10.255 6.09993C10.2528 6.34465 10.1547 6.57874 9.98163 6.75178C9.80858 6.92483 9.57449 7.02299 9.32977 7.02512C9.08506 7.02724 8.8493 6.93317 8.67327 6.76315L6.06647 4.23662L6.06647 13.1033C6.06647 13.3508 5.96813 13.5882 5.7931 13.7633C5.61807 13.9383 5.38067 14.0366 5.13313 14.0366C4.8856 14.0366 4.6482 13.9383 4.47317 13.7633C4.29813 13.5882 4.1998 13.3508 4.1998 13.1033L4.1998 4.23662L1.593 6.76315C1.41797 6.93813 1.18062 7.03642 0.933134 7.03642C0.685647 7.03642 0.448293 6.93813 0.273267 6.76315Z"
                  fill="white"
                />
              </svg>
            </div>
          </div>
          <div
            class="pulmikort__tab pulmikort__tab_mobile my-4"
            :class="{ pulmikort__tab_active: activeTab == 2 }"
            @click="choiceTab(2)"
          >
            Гормонофобия: мифы и&nbsp;реальность
          </div>
          <div v-if="activeTab == 2">
            <input
              @change="toggleSource($event.target.checked)"
              id="tab3"
              type="checkbox"
              class="pulmikort__tabs-body-trigger"
            />
            <div class="pulmikort__tabs-body">
              <div class="pulmikort__tabs-body-speaker">
                <div class="pulmikort__tabs-body-speaker-avatar">
                  <img
                    :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/pulmikort/speaker.jpg`"
                  />
                </div>
                <div class="pulmikort__tabs-body-speaker-info">
                  <div class="pulmikort__tabs-body-speaker-name">
                    Профессор Зайцева О.В.
                  </div>
                  <div class="pulmikort__tabs-body-speaker-description">
                    «Грамотный разговор с родителями может не только решить
                    проблему гормонофобии, но и способствовать формированию
                    здоровья ребенка на всю его будущую жизнь, что очень
                    важно!»*
                  </div>
                </div>
              </div>
              <div class="pulmikort__tabs-body-title">
                Гормонофобия: мифы и&nbsp;реальность
              </div>

              <div class="pulmikort__tabs-body-tabs">
                <div
                  class="pulmikort__tabs-body-tab"
                  :data-coolbox="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/pulmikort/3/%D0%9F%D1%83%D1%8C%D0%BC%D0%B8%D0%BA%D0%BE%D1%80%D1%82_%D0%B2%D0%B8%D0%B4%D0%B5%D0%BE%203.mp4`"
                >
                  <div class="pulmikort__tabs-body-tab-icon">
                    <img
                      :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/pulmikort/icon1.svg`"
                    />
                  </div>
                  <div class="pulmikort__tabs-body-tab-title">
                    Видео эксперта
                  </div>
                </div>
                <a
                  :href="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/pulmikort/3/%D0%9C%D0%BE%D0%B4%D1%83%D0%BB%D1%8C%203%20%D0%BF%D0%BE%D0%BB%D0%B5%D0%B7%D0%BD%D1%8B%D0%B9%20%D0%BC%D0%B0%D1%82%D0%B5%D1%80%D0%B8%D0%B0%D0%BB.pdf`"
                  target="_blank"
                  class="pulmikort__tabs-body-tab"
                >
                  <div class="pulmikort__tabs-body-tab-icon">
                    <img
                      :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/pulmikort/icon2.svg`"
                    />
                  </div>
                  <div class="pulmikort__tabs-body-tab-title">
                    Полезный материал
                  </div>
                </a>

                <!-- <label for="tab3" class="pulmikort__tabs-body-tab">
                  <div class="pulmikort__tabs-body-tab-icon">
                    <img
                      :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/pulmikort/icon3.svg`"
                    />
                  </div>
                  <div class="pulmikort__tabs-body-tab-title">
                    Пульмикорт<sup>®</sup> суспензия
                  </div>
                </label> -->
              </div>
              <div class="pulmikort__tabs-body-content"></div>
            </div>
          </div>
          <div
            class="pulmikort__tab pulmikort__tab_mobile my-4"
            :class="{ pulmikort__tab_active: activeTab == 3 }"
            @click="choiceTab(3)"
          >
            БА: базисная терапия
          </div>
          <div v-if="activeTab == 3">
            <input
              @change="toggleSource($event.target.checked)"
              id="tab4"
              type="checkbox"
              class="pulmikort__tabs-body-trigger"
            />
            <div class="pulmikort__tabs-body">
              <div class="pulmikort__tabs-body-speaker">
                <div class="pulmikort__tabs-body-speaker-avatar">
                  <img
                    :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/pulmikort/speaker.jpg`"
                  />
                </div>
                <div class="pulmikort__tabs-body-speaker-info">
                  <div class="pulmikort__tabs-body-speaker-name">
                    Профессор Зайцева О.В.
                  </div>
                  <div class="pulmikort__tabs-body-speaker-description">
                    «Раннее начало и продолжительная базисная терапия ИГКС
                    позволяют быстрее добиться контроля над астмой и
                    впоследствии снизить терапевтическую нагрузку.»*
                  </div>
                </div>
              </div>
              <div class="pulmikort__tabs-body-title">БА: базисная терапия</div>

              <div class="pulmikort__tabs-body-tabs">
                <div
                  class="pulmikort__tabs-body-tab"
                  :data-coolbox="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/pulmikort/4/%D0%9F%D1%83%D0%BB%D1%8C%D0%BC%D0%B8%D0%BA%D0%BE%D1%80%D1%82_%D0%B2%D0%B8%D0%B4%D0%B5%D0%BE%204.mp4`"
                >
                  <div class="pulmikort__tabs-body-tab-icon">
                    <img
                      :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/pulmikort/icon1.svg`"
                    />
                  </div>
                  <div class="pulmikort__tabs-body-tab-title">
                    Видео эксперта
                  </div>
                </div>
                <a
                  :href="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/pulmikort/4/%D0%9C%D0%BE%D0%B4%D1%83%D0%BB%D1%8C%204%20%D0%BF%D0%BE%D0%BB%D0%B5%D0%B7%D0%BD%D1%8B%D0%B9%20%D0%BC%D0%B0%D1%82%D0%B5%D1%80%D0%B8%D0%B0%D0%BB.pdf`"
                  target="_blank"
                  class="pulmikort__tabs-body-tab"
                >
                  <div class="pulmikort__tabs-body-tab-icon">
                    <img
                      :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/pulmikort/icon2.svg`"
                    />
                  </div>
                  <div class="pulmikort__tabs-body-tab-title">
                    Полезный материал
                  </div>
                </a>

                <!-- <label for="tab4" class="pulmikort__tabs-body-tab">
                  <div class="pulmikort__tabs-body-tab-icon">
                    <img
                      :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/pulmikort/icon3.svg`"
                    />
                  </div>
                  <div class="pulmikort__tabs-body-tab-title">
                    Пульмикорт<sup>®</sup> суспензия
                  </div>
                </label> -->
              </div>
              <div class="pulmikort__tabs-body-content"></div>
            </div>
          </div>
          <div
            class="pulmikort__tab pulmikort__tab_mobile my-4"
            :class="{ pulmikort__tab_active: activeTab == 4 }"
            @click="choiceTab(4)"
          >
            Неотложные состояния
          </div>
          <div v-if="activeTab == 4">
            <input
              @change="toggleSource($event.target.checked)"
              id="tab4"
              type="checkbox"
              class="pulmikort__tabs-body-trigger"
            />
            <div class="pulmikort__tabs-body">
              <div class="pulmikort__tabs-body-speaker">
                <div class="pulmikort__tabs-body-speaker-avatar">
                  <img
                    :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/pulmikort/speaker.jpg`"
                  />
                </div>
                <div class="pulmikort__tabs-body-speaker-info">
                  <div class="pulmikort__tabs-body-speaker-name">
                    Профессор Зайцева О.В.
                  </div>
                  <div class="pulmikort__tabs-body-speaker-description">
                    «Помните, что обструктивное состояние может повториться,
                    поэтому так важно рассказать родителям о неотложной
                    догоспитальной помощи ребенку!»*
                  </div>
                </div>
              </div>
              <div class="pulmikort__tabs-body-title">
                Неотложные обструктивные состояния у&nbsp;детей
              </div>

              <div class="pulmikort__tabs-body-tabs">
                <div
                  class="pulmikort__tabs-body-tab"
                  :data-coolbox="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/pulmikort/5/%D0%9F%D1%83%D0%BB%D1%8C%D0%BC%D0%B8%D0%BA%D0%BE%D1%80%D1%82_%D0%B2%D0%B8%D0%B4%D0%B5%D0%BE%205.mp4`"
                >
                  <div class="pulmikort__tabs-body-tab-icon">
                    <img
                      :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/pulmikort/icon1.svg`"
                    />
                  </div>
                  <div class="pulmikort__tabs-body-tab-title">
                    Видео эксперта
                  </div>
                </div>
                <a
                  :href="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/pulmikort/5/%D0%9C%D0%BE%D0%B4%D1%83%D0%BB%D1%8C%205%20%D0%BF%D0%BE%D0%BB%D0%B5%D0%B7%D0%BD%D1%8B%D0%B9%20%D0%BC%D0%B0%D1%82%D0%B5%D1%80%D0%B8%D0%B0%D0%BB.pdf`"
                  target="_blank"
                  class="pulmikort__tabs-body-tab"
                >
                  <div class="pulmikort__tabs-body-tab-icon">
                    <img
                      :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/pulmikort/icon2.svg`"
                    />
                  </div>
                  <div class="pulmikort__tabs-body-tab-title">
                    Полезный материал
                  </div>
                </a>

                <!-- <label for="tab4" class="pulmikort__tabs-body-tab">
                  <div class="pulmikort__tabs-body-tab-icon">
                    <img
                      :src="`https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/pulmikort/icon3.svg`"
                    />
                  </div>
                  <div class="pulmikort__tabs-body-tab-title">
                    Пульмикорт<sup>®</sup> суспензия
                  </div>
                </label> -->
              </div>
              <div class="pulmikort__tabs-body-content"></div>
            </div>
          </div>
          <div v-if="activeTab == 0">
            <hr class="my-8 d-none d-md-block" style="color: #d6d6d6" />
            <div
              class="pulmikort__dropdown mt-sm-8"
              :class="{ pulmikort__dropdown_opened: activeDropdown }"
            >
              <div
                class="pulmikort__dropdown-head"
                @click="toggleSource(!activeDropdown)"
              >
                <div class="pulmikort__dropdown-title">Источники</div>
                <div class="pulmikort__dropdown-arrow">
                  <svg
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.75 8.75012L11.25 16.2501L3.75 8.75012"
                      stroke="#3C4242"
                      stroke-width="1.5"
                      stroke-linecap="square"
                    />
                  </svg>
                </div>
              </div>
              <div class="pulmikort__dropdown-body">
                <div class="pulmikort__dropdown-body-visible">
                  *видео-цитата имеется в распоряжении портала.
                  <br />БА – бронхиальная астма, ИГКС – ингаляционные
                  глюкокортикостероиды
                </div>
                <div class="pulmikort__dropdown-body-hidden">
                  *видео-цитата имеется в распоряжении портала. БА –
                  бронхиальная астма, ИГКС – ингаляционные глюкокортикостероиды.
                  <br />
                  <br />
                  **-у пациентов с ≥1 обострением бронхиальной астмы средней или
                  тяжелой степени тяжести
                  <ol>
                    <li>
                      Edsbacker S et al. Pulm Pharmacol Ther 2008; 21: 247–258.
                    </li>
                    <li>Mendes et al. Eur Repir J 2003; 21:989-993.</li>
                    <li>
                      Horvath G., Wanner A. European Respiratory Journal.
                      2006;27(1):172-87.
                    </li>
                    <li>
                      Зайцева Ольга Витальевна, Муртазаева О. А. Бронхиальная
                      астма у детей: современные аспекты терапии // ВСП. 2011.
                      №6. URL:
                      <a
                        href="https://cyberleninka.ru/article/n/bronhialnaya-astma-u-detey-sovremennye-aspekty-terapii"
                        target="_blank"
                      >
                        https://cyberleninka.ru/article/n/bronhialnaya-astma-u-detey-sovremennye-aspekty-terapii
                      </a>
                    </li>
                    <li>
                      Camargo CA Jr, Ramachandran S, Ryskina KL et al.
                      Association between common asthma therapies and recurrent
                      asthma exacerbations in children enrolled in a state
                      Medicaid plan. Am J Health Syst Pharm. 2007 May
                      15;64(10):1054-61. doi: 10.2146/ajhp060256.
                    </li>
                    <li>
                      Национальная программа «Бронхиальная астма у детей.
                      Стратегия лечения и профилактики». – 6-е изд., перераб. и
                      доп. – Москва: МедКом-Про, 2021 -228с.
                    </li>
                    <li>
                      Общая характеристика лекарственного препарата
                      Пульмикорт<sup>®</sup>
                      0.25 мг/мл, 0.5 мг/мл (суспензия для ингаляций
                      дозированная). Регистрационное удостоверение
                      ЛП-№(007624)-(РГ-RU) от 12.11.2024.
                    </li>
                    <li>
                      Agertoft et al. New Eng. J. of Medicine 2000; 343: 1064-9.
                    </li>
                    <li>
                      Long-term effects of budesonide or nedocromil in children
                      with asthma. The Childhood Asthma Management Program
                      Research Group. N. Engl J. Med. 2000 Oct.
                      12;343(15):1054-63.
                    </li>
                  </ol>
                  <hr class="my-8" style="color: #d6d6d6" />
                  Информация подготовлена и предоставлена компанией
                  «АстраЗенека». Материал предназначен для специалистов
                  здравоохранения. При назначении ознакомьтесь, пожалуйста, с
                  полной инструкцией по медицинскому применению лекарственного
                  препарата по ссылке. Если Вам стало известно о нежелательной
                  реакции при использовании лекарственного препарата
                  «АстраЗенека», пожалуйста, сообщите эту информацию в
                  медицинский отдел компании.Вы можете написать нам по
                  электронной почте Safety.Russia@astrazeneca.com или связаться
                  с нами по телефону 8 (495) 799-56-99, доб. 2580.Если у Вас
                  есть претензия в отношении качества или подлинности
                  лекарственного препарата «АстраЗенека», пожалуйста, сообщите
                  эту информацию в группу по качеству Компании: электронная
                  почта: productquality.ru@astrazeneca.com, телефон: +7 (495)
                  799 56 99 *
                  <hr class="my-8" style="color: #d6d6d6" />
                  ООО «АстраЗенека Фармасьютикалз», 123112, город Москва, 1-й
                  Красногвардейский проезд, дом 21, строение 1, этаж 30. Тел.:
                  +7 (495) 799-56-99,
                  <br />
                  <a
                    style="text-decoration: underline"
                    href="https://www.astrazeneca.ru"
                    target="_blank"
                  >
                    www.astrazeneca.ru;
                  </a>
                  <a
                    style="text-decoration: underline"
                    href="https://az-most.ru"
                    target="_blank"
                  >
                    az-most.ru
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div v-if="activeTab == 1">
            <hr class="my-8 d-none d-md-block" style="color: #d6d6d6" />
            <div
              class="pulmikort__dropdown mt-sm-8"
              :class="{ pulmikort__dropdown_opened: activeDropdown }"
            >
              <div
                class="pulmikort__dropdown-head"
                @click="toggleSource(!activeDropdown)"
              >
                <div class="pulmikort__dropdown-title">Источники</div>
                <div class="pulmikort__dropdown-arrow">
                  <svg
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.75 8.75012L11.25 16.2501L3.75 8.75012"
                      stroke="#3C4242"
                      stroke-width="1.5"
                      stroke-linecap="square"
                    />
                  </svg>
                </div>
              </div>
              <div class="pulmikort__dropdown-body">
                <div class="pulmikort__dropdown-body-visible">
                  *видео-цитата имеется в распоряжении портала.
                  <br />
                  БОС – бронхообструктивный синдром, БА – бронхиальная астма,
                  ОРИ – острые респираторные инфекции, ИГКС – ингаляционные
                  глюкокортикостероиды.
                </div>
                <div class="pulmikort__dropdown-body-hidden">
                  *видео-цитата имеется в распоряжении портала.
                  <br />
                  БОС – бронхообструктивный синдром, БА – бронхиальная астма,
                  ОРИ – острые респираторные инфекции, ИГКС – ингаляционные
                  глюкокортикостероиды. Зайцева О.В. Бронхообструктивный синдром
                  у детей // Педиатрия. Журнал им. Г.Н. Сперанского. 2005 №4.
                  Клинические рекомендации «Бронхиальная астма» 2024 г. URL
                  https://cr.minzdrav.gov.ru/recomend/359_3. (дата обращения
                  27.05.2025) Global Initiative for Asthma (GINA) 2025.
                  Глобальная инициатива по бронхиальной астме, 2025 [Электронный
                  ресурс], https://ginasthma.org/, дата доступа: 23.05.2025
                  Национальная программа «Бронхиальная астма у детей. Стратегия
                  лечения и профилактики». – 6-е изд., перераб. и доп. – Москва:
                  МедКом-Про, 2021 -228с Li CY, Liu Z. Effect of budesonide on
                  hospitalization rates among children with acute asthma
                  attending paediatric emergency department: a systematic review
                  and meta-analysis. World J Pediatr. 2021 Apr;17(2):152-163.
                  <ol>
                    <li>
                      Зайцева О.В. Бронхообструктивный синдром у детей //
                      Педиатрия. Журнал им. Г.Н. Сперанского. 2005 №4.
                    </li>
                    <li>
                      Клинические рекомендации «Бронхиальная астма» 2024 г. URL
                      <a
                        href="https://cr.minzdrav.gov.ru/recomend/359_3"
                        target="_blank"
                        >https://cr.minzdrav.gov.ru/recomend/359_3</a
                      >
                      . (дата обращения 27.05.2025)
                    </li>
                    <li>
                      Global Initiative for Asthma (GINA) 2025. Глобальная
                      инициатива по бронхиальной астме, 2025 [Электронный
                      ресурс],
                      <a href="https://ginasthma.org/" target="_blank"
                        >https://ginasthma.org/</a
                      >
                      , дата доступа: 23.05.2025
                    </li>
                    <li>
                      Национальная программа «Бронхиальная астма у детей.
                      Стратегия лечения и профилактики». – 6-е изд., перераб. и
                      доп. – Москва: МедКом-Про, 2021 -228с
                    </li>
                    <li>
                      Li CY, Liu Z. Effect of budesonide on hospitalization
                      rates among children with acute asthma attending
                      paediatric emergency department: a systematic review and
                      meta-analysis. World J Pediatr. 2021 Apr;17(2):152-163.
                    </li>
                    <li>
                      Camargo CA Jr, Ramachandran S, Ryskina KL et al.
                      Association between common asthma therapies and recurrent
                      asthma exacerbations in children enrolled in a state
                      Medicaid plan. Am J Health Syst Pharm. 2007 May
                      15;64(10):1054-61. doi: 10.2146/ajhp060256.
                    </li>
                  </ol>
                  <hr class="my-8" style="color: #d6d6d6" />
                  Информация подготовлена и предоставлена компанией
                  «АстраЗенека». Материал предназначен для специалистов
                  здравоохранения. При назначении ознакомьтесь, пожалуйста, с
                  полной инструкцией по медицинскому применению лекарственного
                  препарата по ссылке. Если Вам стало известно о нежелательной
                  реакции при использовании лекарственного препарата
                  «АстраЗенека», пожалуйста, сообщите эту информацию в
                  медицинский отдел компании.Вы можете написать нам по
                  электронной почте Safety.Russia@astrazeneca.com или связаться
                  с нами по телефону 8 (495) 799-56-99, доб. 2580.Если у Вас
                  есть претензия в отношении качества или подлинности
                  лекарственного препарата «АстраЗенека», пожалуйста, сообщите
                  эту информацию в группу по качеству Компании: электронная
                  почта: productquality.ru@astrazeneca.com, телефон: +7 (495)
                  799 56 99 *
                  <hr class="my-8" style="color: #d6d6d6" />
                  ООО «АстраЗенека Фармасьютикалз», 123112, город Москва, 1-й
                  Красногвардейский проезд, дом 21, строение 1, этаж 30. Тел.:
                  +7 (495) 799-56-99,
                  <br />
                  <a
                    style="text-decoration: underline"
                    href="https://www.astrazeneca.ru"
                    target="_blank"
                  >
                    www.astrazeneca.ru;
                  </a>
                  <a
                    style="text-decoration: underline"
                    href="https://az-most.ru"
                    target="_blank"
                  >
                    az-most.ru
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div v-if="activeTab == 2">
            <hr class="my-8 d-none d-md-block" style="color: #d6d6d6" />
            <div
              class="pulmikort__dropdown mt-sm-8"
              :class="{ pulmikort__dropdown_opened: activeDropdown }"
            >
              <div
                class="pulmikort__dropdown-head"
                @click="toggleSource(!activeDropdown)"
              >
                <div class="pulmikort__dropdown-title">Источники</div>
                <div class="pulmikort__dropdown-arrow" v-if="false">
                  <svg
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.75 8.75012L11.25 16.2501L3.75 8.75012"
                      stroke="#3C4242"
                      stroke-width="1.5"
                      stroke-linecap="square"
                    />
                  </svg>
                </div>
              </div>
              <div class="pulmikort__dropdown-body">
                <div class="pulmikort__dropdown-body-visible">
                  *видео-цитата имеется в распоряжении портала.
                  <br />
                  БОС – бронхообструктивный синдром, БА – бронхиальная астма,
                </div>
              </div>
            </div>
          </div>
          <div v-if="activeTab == 3">
            <hr class="my-8 d-none d-md-block" style="color: #d6d6d6" />
            <div
              class="pulmikort__dropdown mt-sm-8"
              :class="{ pulmikort__dropdown_opened: activeDropdown }"
            >
              <div
                class="pulmikort__dropdown-head"
                @click="toggleSource(!activeDropdown)"
              >
                <div class="pulmikort__dropdown-title">Источники</div>
                <div class="pulmikort__dropdown-arrow" v-if="false">
                  <svg
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.75 8.75012L11.25 16.2501L3.75 8.75012"
                      stroke="#3C4242"
                      stroke-width="1.5"
                      stroke-linecap="square"
                    />
                  </svg>
                </div>
              </div>
              <div class="pulmikort__dropdown-body">
                <div class="pulmikort__dropdown-body-visible">
                  *видео-цитата имеется в распоряжении портала.
                  <br />
                  БОС – бронхообструктивный синдром, БА – бронхиальная астма,
                </div>
              </div>
            </div>
          </div>
          <div v-if="activeTab == 4">
            <hr class="my-8 d-none d-md-block" style="color: #d6d6d6" />
            <div
              class="pulmikort__dropdown mt-sm-8"
              :class="{ pulmikort__dropdown_opened: activeDropdown }"
            >
              <div
                class="pulmikort__dropdown-head"
                @click="toggleSource(!activeDropdown)"
              >
                <div class="pulmikort__dropdown-title">Источники</div>
                <div class="pulmikort__dropdown-arrow" v-if="false">
                  <svg
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.75 8.75012L11.25 16.2501L3.75 8.75012"
                      stroke="#3C4242"
                      stroke-width="1.5"
                      stroke-linecap="square"
                    />
                  </svg>
                </div>
              </div>
              <div class="pulmikort__dropdown-body">
                <div class="pulmikort__dropdown-body-visible">
                  *видео-цитата имеется в распоряжении портала.
                  <br />
                  БА – бронхиальная астма, ИГКС – ингаляционные
                  глюкокортикостероиды
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="sticky">
          <RightAside
            @medicationsClick="medicationsClick"
            @calendarClick="calendarClick"
            @libClick="libClick"
            v-if="
              asideItems &&
              asideItems.length &&
              (!NewRecommendations || !NewRecommendations.length)
            "
            :items="asideItems"
            class="failure-page__aside"
          />
          <RecMaterials
            :parent="{ name: 'Пульмикорт', id: 0, type: 'Нозология' }"
            v-else-if="NewRecommendations && NewRecommendations.length"
          />
        </div>
      </div>
    </div>
    <div class="bottom-tip" v-if="activeTab == 0">
      <div class="content">
        Номер одобрения: RU-25908 Дата одобрения: 02.09.2025 Дата истечения:
        01.09.2027
      </div>
    </div>
    <div class="bottom-tip" v-if="activeTab == 1">
      <div class="content">
        Номер одобрения: RU-25908 Дата одобрения: 02.09.2025 Дата истечения:
        01.09.2027
      </div>
    </div>
    <div class="bottom-tip" v-if="activeTab == 2">
      <div class="content">
        Номер одобрения: RU-25908 Дата одобрения: 02.09.2025 Дата истечения:
        01.09.2027
      </div>
    </div>
    <div class="bottom-tip" v-if="activeTab == 3">
      <div class="content">
        Номер одобрения: RU-25908 Дата одобрения: 02.09.2025 Дата истечения:
        01.09.2027
      </div>
    </div>
     <div class="bottom-tip" v-if="activeTab == 4">
      <div class="content">
        Номер одобрения: RU-25908 Дата одобрения: 02.09.2025 Дата истечения:
        01.09.2027
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumbs from "@/components/pageComponents/Breadcrumbs.vue";
import RightAside from "@/components/pageComponents/RightAside.vue";
import RecMaterials from "@/components/pageComponents/RecMaterials.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "Pulmikort",
  data: () => ({
    activeTab: 0,
    activeDropdown: null,
  }),
  components: {
    Breadcrumbs,
    RightAside,
    RecMaterials,
  },
  computed: {
    ...mapGetters(["NewRecommendations"]),
    asideItems() {
      return [
        {
          title: "Препараты АЗ",
          image_desktop: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/cardio-img/aside-1_small.jpg`,
          image: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/cardio-img/aside-1.jpg`,
          theme: "white",
          event: "medicationsClick",
          to: {
            name: "Medications",
            query: {
              therapeutic_areas: "Immunology",
              disease: "skv",
            },
          },
        },
        {
          title: "Мероприятия",
          image: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/cardio-img/aside-2.jpg`,
          image_desktop: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/cardio-img/aside-2_small.jpg`,
          links: [
            {
              event: "calendarClick",
              title: "Предстоящие",
              to: {
                name: "Events",
                query: {
                  therapeutic_areas: "Immunology",
                },
              },
            },
            {
              event: "calendarClick",
              title: "Архив",
              to: {
                name: "ArchiveEvents",
                query: {
                  therapeutic_areas: "Immunology",
                  disease: "skv",
                },
              },
            },
          ],
        },
        {
          title: "Библиотека",
          image: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/cardio-img/aside-3.jpg`,
          image_desktop: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/cardio-img/aside-3_small.jpg`,
          links: [
            {
              event: "libClick",
              title: "Публикации",
              to: {
                name: "TextMaterials",
              },
            },
            {
              event: "libClick",
              title: "Видеоматериалы",
              to: {
                name: "VideoMaterials",
              },
            },
            {
              event: "libClick",
              title: "Подкасты",
              to: {
                name: "Podcasts",
              },
            },
          ],
          theme: "dark",
        },
      ];
    },
  },
  methods: {
    ...mapActions(["fetchNewRecommendations"]),
    choiceTab(ind) {
      this.$set(this, "activeTab", ind);
      this.activeDropdown = null;
      document.querySelectorAll(".pulmikort__tab_active").forEach((i) => {
        i.scrollIntoView({ behavior: "smooth" });
      });
    },
    toggleSource(state) {
      this.activeDropdown = state;
    },
    medicationsClick(item) {
      if (typeof ym !== "undefined") {
        ym(91468266, "reachGoal", "disease page medications click", {
          "disease page medications click": {
            ...this.$root.ymFields,
          },
        });
      }
      this.$router.push(item.to).catch(() => {});
    },
    calendarClick(item) {
      if (typeof ym !== "undefined") {
        ym(91468266, "reachGoal", "disease page events click", {
          "disease page events click": {
            ...this.$root.ymFields,
          },
        });
      }
      this.$router.push(item.to).catch(() => {});
    },
    libClick(item, text) {
      if (typeof ym !== "undefined") {
        ym(91468266, "reachGoal", "disease page library materails click", {
          "disease page library materails click": {
            "block name": text,
            ...this.$root.ymFields,
          },
        });
      }
      this.$router.push(item.to).catch(() => {});
    },
    toTop() {
      document.querySelectorAll(".pulmikort__tab_active").forEach((i) => {
        i.scrollIntoView({ behavior: "smooth" });
      });
    },
  },
  created() {
    this.fetchNewRecommendations({
      url: this.$route.path,
      without_rec_cards: "false",
    });
  },
};
</script>

<style lang="scss" scoped>
.pulmikort {
  background-color: #f6fafb;
  padding-top: 32px;

  &__title {
    font-family: "Roboto Slab", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 42px;
    line-height: 48px;
    color: #000000;

    @media screen and (max-width: 767px) {
      font-size: 32px;
    }
  }

  &__body {
    margin-top: 40px;
    display: grid;
    column-gap: 136px;
    grid-template-columns: 2fr 280px;
    @media screen and (max-width: 1220px) {
      grid-template-columns: 100%;
      row-gap: 40px;
    }
  }

  &__banner {
    width: 100%;
    height: 300px;
    background-image: url("https://storage.yandexcloud.net/" + $VUE_APP_BACKET_NAME + "/media/content/public/assets/img/pulmikort/banner.jpg");
    background-size: cover;
    background-position: center right;
    padding: 60px 20px;
    border-radius: 20px;
    @media screen and (max-width: 1220px) {
      padding: 35px 20px;
    }
    @media screen and (max-width: 767px) {
      padding: 16px;
      background-image: url("https://storage.yandexcloud.net/" + $VUE_APP_BACKET_NAME + "/media/content/public/assets/img/pulmikort/banner_mob.jpg");
      height: 540px;
      background-position: bottom center;
    }

    &-text {
      max-width: 55%;
      @media screen and (max-width: 767px) {
        max-width: none;
      }
    }

    &-title {
      margin-bottom: 24px;
      font-family: "Roboto Slab", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 22px;
      line-height: 29px;
      color: #ffffff;
      @media screen and (max-width: 767px) {
        font-size: 18px;
        line-height: 24px;
      }
    }

    &-description {
      padding-top: 24px;
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;
      color: #ffffff;
      border-top: 1px solid rgba(255, 255, 255, 0.2);
    }
  }

  &__video {
    margin: 40px 0;
    width: 100%;
    border-radius: 20px;
    overflow: hidden;

    & video {
      width: 100%;
      height: auto;
      display: block;
    }
  }

  &__tabs {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    column-gap: 8px;
    @media screen and (max-width: 1220px) {
      grid-template-columns: repeat(2, 1fr);
      gap: 8px;
    }
    @media screen and (max-width: 767px) {
      display: none;
    }

    &-body {
      padding: 20px;
      margin-top: 32px;
      background-color: #fff;
      box-shadow: 0px 10px 20px rgba(187, 215, 229, 0.4);
      border-radius: 20px;

      &-speaker {
        margin-bottom: 40px;
        display: grid;
        grid-template-columns: 260px 1fr;
        column-gap: 32px;
        align-items: center;
        @media screen and (max-width: 1220px) {
          grid-template-columns: 180px 1fr;
        }
        @media screen and (max-width: 767px) {
          grid-template-columns: 1fr;
          row-gap: 12px;
        }

        &-avatar {
          width: 100%;
          aspect-ratio: 1/1;
          border-radius: 20px;
          overflow: hidden;

          & img {
            width: 100%;
            display: block;
          }
        }

        &-name {
          margin-bottom: 20px;
          font-family: "Roboto Slab", sans-serif;
          font-style: normal;
          font-weight: 400;
          font-size: 22px;
          line-height: 29px;
          color: #00bc88;
          @media screen and (max-width: 767px) {
            font-size: 20px;
            margin-bottom: 12px;
          }
        }

        &-description {
          font-family: "Roboto", sans-serif;
          font-style: italic;
          font-weight: 400;
          font-size: 18px;
          line-height: 21px;
          color: #000000;
          @media screen and (max-width: 767px) {
            font-size: 16px;
          }
        }
      }

      &-title {
        margin-bottom: 20px;
        font-family: "Roboto Slab", sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 32px;
        line-height: 42px;
        color: #00bc88;
        @media screen and (max-width: 1220px) {
          font-size: 24px;
        }
        @media screen and (max-width: 767px) {
          font-size: 20px;
          line-height: 24px;
        }
      }

      &-tabs {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        gap: 16px;
        @media screen and (max-width: 1220px) {
          flex-wrap: wrap;
        }
      }

      &-tab {
        position: relative;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 8px;
        border: 1px solid #d6d6d6;
        background-color: #fff;
        transition: 0.3s;
        padding: 10px;
        border-radius: 10px;
        font-family: "Roboto Slab", sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 21px;
        color: #000000;
        width: 100%;
        white-space: nowrap;
        cursor: pointer;
        &:hover {
          background-color: #f0519f;
          color: #fff;
        }
      }

      &-content {
        margin-top: 40px;
        display: none;

        & img {
          max-width: 100%;
          @media screen and (max-width: 767px) {
            width: 100%;
          }
        }
      }

      &-trigger {
        display: none;

        &:checked {
          & ~ .pulmikort__tabs-body {
            & .pulmikort__tabs-body-tabs {
              & label.pulmikort__tabs-body-tab {
                background-color: #f0519f;
                color: #fff;
              }
            }

            & .pulmikort__tabs-body-content {
              display: block;
            }
          }

          & ~ .pulmikort__to-top {
            display: flex;
          }
        }
      }
    }
  }

  &__tab {
    padding: 16px 20px;
    border-radius: 10px;
    font-family: "Roboto Slab", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 21px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #000000;
    cursor: pointer;
    transition: 0.3s;
    background-color: #fff;
    @media screen and (max-width: 1220px) {
      padding: 16px;
    }

    &_disable {
      pointer-events: none;
      opacity: 0.5;
    }

    &_mobile {
      display: none;
      @media screen and (max-width: 767px) {
        display: block;
      }
    }

    &:hover {
      background-color: #f0519f;
      color: #fff;
    }

    &_active {
      background-color: #f0519f;
      color: #fff;
    }
  }

  &__dropdown {
    &-head {
      margin-bottom: 20px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      cursor: pointer;
    }

    &-title {
      font-family: "Roboto Slab", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 23px;
      line-height: 29px;
      color: #1f1f1f;
      @media screen and (max-width: 767px) {
        font-size: 16px;
        color: #505050;
      }
    }

    &-arrow {
      margin-left: auto;
      transition: 0.3s;
      @media screen and (max-width: 767px) {
        display: none;
      }
    }

    &-body {
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;

      & ol {
        margin: 16px 0;
        list-style-type: decimal;
        margin-left: 1em;

        & li {
          &:not(:last-child) {
            margin-bottom: 4;
          }
        }
      }

      &-visible {
        display: block;
        color: #3c4242;
      }

      &-hidden {
        display: none;
        color: #888888;
      }
    }

    &_opened {
      & .pulmikort__dropdown {
        &-arrow {
          transform: rotate(180deg);
        }

        &-body {
          &-visible {
            display: none;
          }

          &-hidden {
            display: block;
          }
        }
      }
    }
  }

  & sup {
    vertical-align: super;
    font-family: inherit;
    font-style: normal;
    font-weight: inherit;
    font-size: 65%;
    line-height: 1;
    color: currentColor;
    white-space: nowrap;
  }

  & .text-1 {
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 120%;
    color: #2e2e2e;
    @media screen and (max-width: 1220px) {
      font-size: 18px;
    }
    @media screen and (max-width: 767px) {
      font-size: 16px;
    }
  }

  & .text-2 {
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 120%;
    color: #2e2e2e;
    @media screen and (max-width: 1220px) {
      font-size: 16px;
    }
  }

  & .title-1 {
    font-family: "Roboto Slab", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 22px;
    line-height: 120%;
    color: #f0519f;
    @media screen and (max-width: 767px) {
      font-size: 18px;
    }
  }

  & .button {
    border-radius: 8px;

    &_green {
      background-color: #00bc88;
      color: #fff;
      gap: 8px;
    }

    &_pink {
      background-color: #f0519f;
      color: #fff;
    }
  }

  &__to-top {
    display: none;
    margin-left: auto;
    margin-top: 16px;
    width: fit-content;
  }

  & .sticky {
    @media screen and (min-width: 1221px) {
      position: sticky;
      top: 126px;
      height: fit-content;
    }
  }
}
</style>

<style lang="scss">
.pulmikort {
  & + .bottom-tip {
    display: none;
  }

  & > .bottom-tip {
    margin-top: 0 !important;
    padding-top: 80px;
    margin-bottom: 0 !important;
    padding-bottom: 24px;
    background-color: #f6fafb;
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #b2b4b4;
  }
}
</style>